import { f7, useStore } from 'framework7-react';
import { useEffect } from 'react';
import { usePaymentList } from './api/payment/usePaymentList';
import { useLoadCustomer } from './useLoadCustomer';
import { useToast } from './useToast';
import { customerInfoApi } from '@/api/customerApi';
import { AuthInfoState, initialState } from '@/config/initialState';
import { store } from '@/config/store';
import { storeDispatch } from '@/utils/store';

export const useGmoRegisterAndEditRedirect = () => {
  const router = f7.views.main.router;
  const authInfo = useStore(store, 'authInfo') as AuthInfoState;
  const customerId = localStorage.getItem('m_customer_id');
  const token = localStorage.getItem('token');
  const { openToast } = useToast();
  const { updatePaymentList, isFetched, isFetching } = usePaymentList(false);

  const handleGmoRegisterAndEditRedirect = async (
    status: string,
    isLoggedIn: boolean,
  ) => {
    if (!isLoggedIn) return;
    const mCustomerId = window.localStorage.getItem('m_customer_id');
    const reserveAmount = window.localStorage.getItem('reserve_amount');

    customerInfoApi({ m_customer_id: Number(mCustomerId) }).then(
      async (data) => {
        const {
          customer,
          cars,
          bill_infomations,
          payment_methods,
          prepaids,
          informations,
          campaigns,
        } = data.data;
        Promise.all([
          storeDispatch(
            'setCarItemInfo',
            'carItemInfo',
            cars ? cars[0] : initialState.carItemInfo,
          ),
          storeDispatch('setCustomerInfo', 'customerInfo', customer),
          storeDispatch('setCarsInfo', 'carsInfo', cars),
          storeDispatch('setBillsInfo', 'billsInfo', bill_infomations),
          storeDispatch(
            'setPaymentMethodsInfo',
            'paymentMethodsInfo',
            payment_methods,
          ),
          storeDispatch(
            'setAdvancePaymentsInfo',
            'advancePaymentsInfo',
            prepaids,
          ),
          storeDispatch(
            'setNotificationsInfo',
            'notificationsInfo',
            informations,
          ),
          storeDispatch('setCampaignsInfo', 'campaignsInfo', campaigns),
          storeDispatch(
            'setWarranties',
            'warranties',
            cars?.[0]?.warranties || [],
          ),
          storeDispatch(
            'setNextWarranties',
            'nextWarranties',
            cars?.[0]?.next_warranty || [],
          ),
          storeDispatch(
            'setCurrentWarranty',
            'currentWarranty',
            cars?.[0]?.warranties?.[0],
          ),
          storeDispatch(
            'setNextWarranty',
            'nextWarranty',
            cars?.[0]?.next_warranty?.[0],
          ),
        ]);
      },
    );

    switch (status) {
      case 'gmo_success':
        if (isLoggedIn && !isFetched && !isFetching) {
          updatePaymentList(Number(mCustomerId));
          openToast(
            'カードの登録・編集が完了しました。',
            'toast-success',
            3000,
            true,
            'top',
          );
          return;
        }
        break;
      case 'gmo_cancel':
        if (isLoggedIn) {
          openToast(
            'カードの登録・編集がキャンセルされました。',
            'toast-failed',
            3000,
            true,
            'top',
          );
        }
        break;
    }
  };

  return {
    handleGmoRegisterAndEditRedirect,
  };
};
